import React, { useEffect } from 'react';
import { Printer, X } from 'lucide-react';
import FloorPlan from './FloorPlan';

// Printable floor plan (page 1) plus every table with its names (page 2+).
export const PrintLayout = ({ tables, features, room, namesFor, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  const noop = () => {};
  return (
    <>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #print-seating-layout, #print-seating-layout * { visibility: visible !important; }
          #print-seating-layout { position: absolute; left: 0; top: 0; width: 100%; }
          #print-seating-layout .print-hidden { display: none !important; }
          .layout-page-break { page-break-before: always; }
          @page { size: letter landscape; margin: 0.4in; }
        }
      `}</style>
      <div className="fixed inset-0 z-50 bg-black/50 flex items-start justify-center p-4 overflow-auto" onClick={onClose}>
        <div id="print-seating-layout" data-testid="print-layout-modal" onClick={(e) => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-6xl p-6">
          <div className="print-hidden flex items-center justify-between mb-4">
            <h2 className="font-serif text-2xl">Reception layout</h2>
            <div className="flex gap-2">
              <button data-testid="print-layout-print" onClick={() => window.print()} className="btn-primary text-sm px-4 py-2 rounded-full inline-flex items-center gap-1.5"><Printer className="w-4 h-4" /> Print or save as PDF</button>
              <button data-testid="print-layout-close" onClick={onClose} aria-label="Close" className="p-2"><X className="w-5 h-5" /></button>
            </div>
          </div>
          <div className="pointer-events-none">
            <FloorPlan tables={tables} features={features} room={room} namesFor={namesFor} zoom={1} selected={null} onSelect={noop} onMoveTable={noop} onChangeFeature={noop} onCommitFeatures={noop} onDropGuest={noop} />
          </div>
          <div className="layout-page-break mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
            {tables.map((t) => (
              <div key={t.id} className="break-inside-avoid border border-[#EFE3D8] rounded-xl p-3">
                <p className="font-serif text-lg text-[#7B2C3B]">{t.label} <span className="text-xs text-[#9A8A7E]">({namesFor(t).length}/{t.seats})</span></p>
                <ol className="text-sm list-decimal pl-5">{namesFor(t).map((n, i) => <li key={i}>{n}</li>)}</ol>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PrintLayout;
